const newsdetails = () => {
  return (
    <>
      <div>
        <div className="bg-[#fcfcfc] pt-[2rem]"></div>
        <div className="bg-[#fcfcfc] pt-[2rem]">
          <div className="max-w-[70rem] mx-auto sm:px-[10rem] lg:grid md:grid md:justify-center lg:justify-between ">
            <div className="sm:max-w-[50rem] lg:mx-auto md:mx-[5rem] mx-[2rem] my-[3rem] flex flex-col justify-center items-center text-justify gap-4">
              <h1 className="font-bold text-[18px]">
                TCS and Nippon Express Group Announce Strategic Partnership to
                Strengthen Logistics and Trade Connectivity
              </h1>
              <p>
                <span className="font-bold">Karachi, February 03 -</span> TCS
                Group, one of Pakistan’s most established and trusted logistics
                conglomerates, has formalized a strategic partnership with
                Nippon Express (South Asia & Oceania) Pte. Ltd., a subsidiary of
                Nippon Express Holdings, Inc. (Nippon Express Group) of Japan,
                under which Nippon Express Group has acquired a minority stake
                in TCS Logistics (Private) Limited.
              </p>
            </div>

            <div className="flex justify-center mx-[2rem]">
              <img
                src="/Home/1770105415086.jpg"
                alt=""
                className="xl:h-[27rem] lg:h-[26rem] md:h-[20rem] sm:h-[20rem] h-[17rem] leadership-images"
              />
            </div>
            <div className="sm:max-w-[50rem] lg:mx-auto md:mx-[5rem] mx-[2rem]  flex flex-col justify-center items-center text-justify gap-4">
              <h1 className="font-bold mt-[.5rem]">
                (TCS Group President Saira Awan Malik, Chairman Khalid Awan, and
                NX South Asia & Oceania President Katsuhito Kobayashi)
              </h1>
            </div>
          </div>
        </div>
        <div className="sm:max-w-[50rem] lg:mx-auto md:mx-[5rem] mx-[2rem] my-[3rem] flex flex-col justify-center items-center text-justify gap-4">
          <p>
            Through this partnership, Pakistani businesses and consumers stand
            to gain enhanced connectivity with global markets via the Nippon
            Express Group’s extensive international presence, while the Nippon
            Express Group will leverage TCS Logistics’ nationwide network,
            operational expertise, and trusted customer base to strengthen
            logistics capabilities in Pakistan.
          </p>
          <p>
            Commenting on this partnership, Saira Awan Malik, President, TCS
            Group, said, “This partnership with Nippon Express is a landmark
            moment for TCS and Pakistan’s logistics sector. It reflects
            international confidence in Pakistan’s market fundamentals and
            enhances our ability to deliver world-class supply chain solutions
            that connect Pakistani businesses to the global economy.”
          </p>
          <p>
            Over 4 decades, the TCS Group has built a strong reputation for
            reliability, nationwide reach, and service excellence. TCS
            Logistics, a core logistics arm of the TCS Group, operates an
            extensive domestic logistics infrastructure spanning land
            transportation, warehousing, distribution, and cross-border
            logistics connectivity.
          </p>
          <p>
            Through close collaboration, TCS Logistics aims to contribute to the
            modernization of Pakistan’s logistics ecosystem and provide
            technology enabled logistics services and value-added supply chain
            solutions for customers operating in and through Pakistan.
          </p>
          <p>
            Meanwhile Nippon Express, in a statement said that through this
            transaction, the company will leverage TCS Logistics’ domestic
            network and customer base to strengthen logistics operations in
            Pakistan and will also work to enhance trade lanes to Central Asia
            originating from Pakistan, focusing on developing new logistics
            services and identifying emerging needs.
          </p>
          <p>
            The Nippon Express Group is one of the world’s leading logistics
            conglomerates, with operations spanning more than 50 countries and
            regions across Asia, Europe, the Americas, and Oceania. The Nippon
            Express Group provides comprehensive logistics solutions covering
            air and ocean freight, land transportation, warehousing, supply
            chain management, and specialized logistics services, with a strong
            focus on end-to-end supply chain solutions and emphasis on
            accelerating business growth in South Asia and the surrounding
            regions.
          </p>
          <p>
            The partnership is expected to facilitate imports and exports and
            support trade corridors linking Pakistan with key regional markets.
            It marks an important development in foreign direct investment into
            Pakistan’s logistics sector and highlights the importance of
            partnering with reputable legacy enterprises that bring local
            knowledge, operational scale, and brand trust.
          </p>
        </div>
      </div>
    </>
  );
};

export default newsdetails;
